import React, { useEffect, useState } from "react";
import ChangeUserView from "./ChangeUserView";
import { useNavigate, useParams } from "react-router-dom";
import ApiHelper from "../../api/api_helper";
import LoadingIndicator from '../loading/LoadingIndicator';
import { useDialog } from "../../context/dialog_context";
import { useAuth } from "../../context/user_context";

const ChangeUserController = () => {
    const { userId } = useParams();

    const [userData, setUserData] = useState({});
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [, setApiError] = useState('');
    const [isLoading, setIsLoading] = useState('');

    const navigate = useNavigate();
    const { showDialog } = useDialog();
    const auth = useAuth();

    // Initial State
    useEffect(() => {
        getUserById();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Fetch User Data
    const getUserById = async () => {
        try {
            setIsLoading(true);
            const response = await ApiHelper.get(`/auth/user?id=${userId}`);
            if (response.status !== 200) {
                throw response;
            }
            setUserData(response.data.data);

        } catch (error) {
            setApiError(error.data);
        } finally {
            setIsLoading(false);
        }
    };

    const updateUserDataByKey = (key, newValue) => {
        setUserData((prevState) => ({
            ...prevState,
            [key]: newValue,
        }));
    };

    const handlePassword = (event) => {
        setPassword(event.target.value);
    };

    const handleConfirmPassword = (event) => {
        setConfirmPassword(event.target.value)
    };


    const previousPage = () => {
        navigate(-1);
    };

    const onClickSubmitButton = async () => {
        const requiredFields = [
            ['firstname', 'ชื่อ'],
            ['lastname', 'นามสกุล'],
            ['telephone', 'เบอร์โทรศัพท์'],
            ['username', 'Username'],
        ];
        const emptyField = requiredFields.find(([key]) => !String(userData[key] ?? '').trim());
        if (emptyField) {
            showDialog('ข้อมูลไม่ครบ', `กรุณากรอก ${emptyField[1]}`);
            return;
        }

        // เว้นว่างรหัสผ่านไว้ = ไม่เปลี่ยนรหัสผ่าน
        if ((password !== '' || confirmPassword !== '') && password !== confirmPassword) {
            showDialog('รหัสผ่านไม่ตรงกัน', 'กรุณากรอก Password และ Confirm Password ให้ตรงกัน');
            return;
        }

        const payload = {
            firstname: userData.firstname,
            lastname: userData.lastname,
            telephone: userData.telephone,
            username: userData.username,
            role: userData.role,
        };
        if (password !== '') {
            payload.password = password;
        }

        try {
            setIsLoading(true);
            const response = await ApiHelper.put(`/auth/user/${userId}`, payload);
            if (response.status !== 200) {
                throw response;
            }

            // แก้ข้อมูลของตัวเอง ให้ชื่อบนระบบอัปเดตตาม
            if (auth?.user && String(auth.user.id) === String(userId)) {
                const { id, username, role, firstname, lastname } = response.data.data;
                auth.setUser({ ...auth.user, id, username, role, firstname, lastname });
            }

            showDialog('สำเร็จ', 'บันทึกข้อมูลสมาชิกเรียบร้อย');
            navigate(-1);
        } catch (error) {
            showDialog('เกิดข้อผิดพลาด', error?.data?.data || 'ไม่สามารถบันทึกข้อมูลได้');
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return <LoadingIndicator />
    };

    return <ChangeUserView
        userData={userData}
        updateUserDataByKey={updateUserDataByKey}
        handlePassword={handlePassword}
        handleConfirmPassword={handleConfirmPassword}
        onClickSubmitButton={onClickSubmitButton}
        previousPage={previousPage}
    />
}

export default ChangeUserController;